module.exports = __webpack_public_path__ + "img/modern-bedroom-3264490.8197872c.jpg";